import { interceptionObj } from "./localData";
import axios from "@/libs/api.request";
import {getInboundProof} from "@/api/order/list";
export const fields = ({ that, type }) => {
  let all = type == "all" ? true : false; //全部订单
  let inbound = type == "inbound" ? true : false; //入库单
  let customerWait = type == "customer-wait" ? true : false; //待客户确认重量
  let customerIn = type == "customer-in" ? true : false; //客户拦截
  let del = type == "delete" ? true : false; //删除订单
  return [
    {
      type: "checkbox",
      fixed: "left",
      align: "center",
      width: 60,
    },
    // {
    //   name: () => that.$t("serialNumber"),
    //   type: "seq",
    //   align: "center",
    //   width: 60
    // },
    {
      name: () => that.$t("order_number"),
      key: "airway_number",
      align: "center",
      fixed: "left",
      copy: true,
      width: 160,
      header: {
        copy: true, //头部复制
      },
      showOverflow: false,
      component: "Button",
      bind: {
        type: "primary",
        size: "small",
      },
      methods: {
        click({ row }) {
          that
            .handleRequestMethods("getOrderDetails", row.airway_number)
            .then((res) => {
              that.getModal("orderDetail").open(
                {
                  dataDetails: res.payload,
                  pageText: type,
                },
                function () {
                  this.setTitle(row.airway_number);
                }
              );
            });
        },
      },
    },

    {
      name: () => that.$t("packageType"),
      key: "bag_type",
      align: "center",
      tooltip: true,
      minWidth: 100,
      show: () => all,
    },
    // 删除订单隐藏
    {
      name: () => that.$t("order_type_t"),
      key: "type",
      align: "left",
      tooltip: true,
      minWidth: 120,
    },
    // 拦截订单显示
    {
      name: () => that.$t("barPhase"),
      key: "interception_phase",
      align: "center",
      tooltip: true,
      show: () => customerIn,
      minWidth: 80,
      methods: {
        render({ row }) {
          return interceptionObj[row.interception_phase]
            ? that.$t(interceptionObj[row.interception_phase])
            : row.interception_phase;
        },
      },
    },
    {
      name: () => that.$tz('货物,状态'),
      key: 'trace_status',
      minWidth: 110,
    },
    {
      name: () => that.$t("tracker_code"),
      key: "status",
      align: "center",
      tooltip: true,
      width: 150,
      render(h, p) {
        return h('Button', {
          attrs: {
            type: 'primary',
            size: 'small'
          },
          on: {
            click() {
              p.row.status === 'POD' && (that.openLoading(), axios.request({
                url: '/api/signPic/' + p.row.airway_number,
                method: 'get',
              }).then(res => {
                that.closeLoading()
                console.log('res :>> ', res);
                that.getModal('preview').open({ src: res.data })
              }))
            }
          }
        }, p.row.status)
      }
    },
    {
      name: () => 'channel',
      key: 'status_flag',
      minWidth: 150,
      show: () => all,

    },
    {
      name: () => that.$t("tracker_description"),
      key: "status_remarks",
      align: "center",
      tooltip: true,
      minWidth: 110,
    },
    {
      name: () => that.$t("status_cn"),
      key: "status_cn",
      align: "center",
      tooltip: true,
      minWidth: 110,
    },
    {
      name: () => that.$t("status_time" + (type == 'customer-in' ? '1' : '')),
      key: "status_time",
      align: "center",
      tooltip: true,
      minWidth: 110,
    },
    {
      name: () => that.$t("NextProcessing"),
      key: "current_processor",
      align: "center",
      tooltip: true,
      minWidth: 110,
      show: () => all,
    },
    {
      name: () => that.$tz("是否开箱"),
      key: "unbox",
      align: "center",
      tooltip: true,
      minWidth: 110,
      show: () => all,
    },
    {
      name: () => that.$tz("是否,闭环"),
      key: "loop",
      align: "center",
      tooltip: true,
      minWidth: 110,
      show: () => all,
    },
    {
      name: () => that.$tz("装袋失败原因"),
      key: "bag_msg",
      align: "center",
      minWidth: 130,
    },
    {
      name: () => that.$tz("运费"),
      key: "confirmation_amount",
      align: "center",
      minWidth: 130,
    },
    {
      name: () => that.$t("from_country"),
      key: "from_country_title",
      align: "center",
      minWidth: 80,
    },
    {
      name: () => that.$t("target_country"),
      key: "to_country_title",
      align: "center",
      minWidth: 80,
    },
    {
      name: () => that.$t("city_name"),
      key: "city_name",
      align: "center",
      minWidth: 80,
    },
    {
      name: () => that.$tz("区域"),
      key: "area",
      align: "center",
      minWidth: 80,
    },
    // 删除订单隐藏
    {
      name: () => that.$t("localFaction"),
      key: "deliver",
      align: "left",
      tooltip: true,
      minWidth: 80,
      show: () => !del,
    },
    {
      name: () => that.$t("is_goods") + that.$t("plan_location"),
      key: "goods_location",
      align: "left",
      tooltip: true,
      minWidth: 80,
      show: () => all,
    },
    // {
    //   name: () => {
    //     return '短地址类型'
    //   },
    //   key: 'short_address_type',
    //   align: "center",
    //   minWidth: 100,
    //   show: () => true,
    // },
    // {
    //   name: () => {
    //     return '短地址'
    //   },
    //   key: 'short_address',
    //   align: "center",
    //   minWidth: 120,
    //   show: () => true,
    // },
    {
      name: () => that.$t("taxationType"),
      key: "ddx",
      tooltip: true,
      minWidth: 80,
      show: () => all,
    },
    {
      name: () => that.$t("delivery") + that.$t("mode"),
      key: "delivery_mode",
      align: "left",
      tooltip: true,
      minWidth: 80,
      show: () => all,
    },
    {
      name: () => that.$t("order_refCode"),
      key: "agent_refer_code",
      align: "center",
      header: {
        copy: true, //头部复制
      },
      minWidth: 130,
    },
    {
      name: () => that.$t("order_userRef"),
      key: "client_refer_code",
      align: "center",
      minWidth: 80,
      header: {
        copy: true, //头部复制
      },
    },
    {
      name: () => that.$t("order_type" + (type == 'customer-in' ? '1' : '')),
      key: "cod_type",
      align: "center",
      tooltip: true,
      minWidth: 80,
    },
    {
      name: () => that.$t("order_price"),
      key: "cod_amount",
      align: "center",
      minWidth: 80,
    },
    // 删除订单隐藏
    {
      name: () => that.$t("DeclaredValue"),
      key: "values",
      align: "center",
      minWidth: 80,
      header: {
        copy: true, //头部复制
      },
      show: () => !del,
    },
    {
      name: () => that.$t("salesman"),
      key: "staffAccount",
      align: "center",
      minWidth: 80,
    },
    {
      name: () => that.$t("serviceAccount"),
      key: "serviceAccount",
      align: "center",
      header: {
        copy: true, //头部复制
      },
      minWidth: 120,
    },
    {
      name: () => that.$tz('分公司,客服'),
      key: 'branch_customer_service',
      minWidth: 110,
    },
    {
      name: () => that.$t("ownership"),
      key: "ownership_name",
      align: "center",
      minWidth: 140,
    },
    {
      name: () => that.$t("shipper_company_cn"),
      key: "shipper_company_cn",
      align: "left",
      minWidth: 100,
      show: () => all,
    },
    {
      name: () => that.$t("clientName"),
      key: "customerAccount",
      align: "center",
      header: {
        copy: true, //头部复制
      },
      minWidth: 120,
    },
    // 删除订单隐藏
    {
      name: () => that.$t("Sender"),
      key: "shipper_name",
      align: "center",
      minWidth: 80,
      show: () => !del,
    },
    {
      name: () => that.$t("createTime"),
      key: "create_time",
      align: "center",
      tooltip: true,
      minWidth: 110,
    },
    {
      name: () => that.$t("inboundTime"),
      key: "inbound_time",
      align: "center",
      tooltip: true,
      minWidth: 110,
      show: () => all,
      methods: {
        render({ value }) {
          return value ? value : "-";
        },
      },
    },
    {
      name: () => that.$t("outboundTime"),
      key: "outbound_time",
      align: "center",
      tooltip: true,
      minWidth: 110,
      show: () => all,
      methods: {
        render({ value }) {
          return value ? value : "-";
        },
      },
    },

    {
      name: () => that.$t("order_pcs"),
      key: "quantity",
      align: "center",
      tooltip: true,
      minWidth: 80,
    },
    {
      name: () => that.$t("charge_params"),
      key: "actual_weight",
      align: "center",
      tooltip: true,
      minWidth: 80,
    },
    {
      name: () => that.$t("charging_volume"),
      key: "charge_volume",
      align: "center",
      tooltip: true,
      minWidth: 80,
    },

    {
      name: () => that.$tz("仓库,服务项目"),
      key: "warehouse_service_name",
      align: "center",
      minWidth: 80,
    },
    // 拦截订单显示
    {
      name: () => that.$t("request_time"),
      key: "block_time",
      align: "center",
      minWidth: 170,
      show: () => customerIn,
      methods: {
        render({ value }) {
          return value ? value : "-";
        },
      },
    },
    {
      name: () => that.$t("length") + "(CM)",
      key: "length",
      align: "center",
      minWidth: 80,
    },
    {
      name: () => that.$t("width") + "(CM)",
      key: "width",
      align: "center",
      minWidth: 80,
    },
    {
      name: () => that.$t("height") + "(CM)",
      key: "height",
      align: "center",
      minWidth: 80,
    },
    // 待确认订单、异常待处理隐藏
    {
      name: () => that.$t("check_weight"),
      key: "check_weight",
      align: "center",
      header: {
        copy: true, //头部复制
      },
      width: 120,
      show: () => !customerWait,
    },
    {
      name: () =>
        that.$t("b2bClient") + that.$t("confirmWeight") + that.$t("time"),
      key: "confirm_weight_time",
      align: "center",
      minWidth: 100,
      show: () => all,
    },
    {
      name: () => that.$t("confirmWeight") + that.$t("operate"),
      key: "operator_name",
      align: "center",
      minWidth: 130,
      show: () => inbound,
    },
    {
      name: () => that.$t("confirmWeight") + that.$t("time"),
      key: "operator_time",
      align: "center",
      minWidth: 170,
      show: () => inbound,
    },
    {
      name: () => that.$t("warehouseName"),
      key: "warehouse_name",
      align: "left",
      minWidth: 80,
      show: () => all,
    },
    {
      name: () => that.$t("cancel") + that.$t("returnPick"),
      key: "is_cancel",
      minWidth: 80,
      show: () => all,
      methods: {
        render({ value }) {
          return that.$t(value);
        },
      },
    },
    // 入库订单状态不同
    {
      name: () => that.$t("orderType"),
      key: inbound ? "confirmStatus" : "code_status_txt",
      align: "center",
      minWidth: 120,
    },
    {
      name: () => that.$t("order_recivre"),
      key: "consignee_contact",
      align: "center",
      minWidth: 80,
      type: "toolbar",
    },
    {
      name: () => that.$t("order_address"),
      key: "consignee_address",
      align: "center",
      type: "toolbar",
      minWidth: 80,
    },
    {
      name: () => that.$t("order_phone"),
      key: "consignee_cellular",
      align: "center",
      type: "toolbar",
      minWidth: 150,
      header: {
        copy: true, //头部复制
      },
      copy: true,
    },
    {
      name: () => that.$t("skuName"),
      key: "goods_name",
      align: "center",
      minWidth: 80,
      show: () => all,
    },
    {
      name: () => that.$t("hsCode"),
      key: "goods_hs_code",
      align: "center",
      minWidth: 80,
      show: () => all,
    },
    {
      name: () => that.$t("skuWeight1"),
      key: "weight",
      align: "center",
      minWidth: 80,
      show: () => all,
    },
    {
      name: () => that.$t("order_goods"),
      key: "goods_quantity",
      align: "center",
      minWidth: 80,
    },
    {
      name: () =>
        that.$t("des_goods") + that.$t("gather") + that.$t("noofpieces"),
      key: "goods_count",
      align: "center",
      minWidth: 80,
      show: () => all,
    },
    {
      name: () => "sku",
      key: "goods_title",
      align: "center",
      minWidth: 80,
      show: () => all,
      copy: true,
      header: {
        copy: true
      }
    },
    {
      name: () => that.$t("channel_code"),
      key: "transport_mode",
      align: "center",
      minWidth: 80,
      show: () => all,
    },
    {
      name: () => (all ? that.$t("placeOrder") : "") + that.$t("order_desc"),
      key: "remarks",
      align: "center",
      minWidth: 80,
    },
    {
      name: () =>
        (all ? that.$t("domestic") : that.$t("Warehouse Remark")),
      key: "batch_remarks",
      align: "center",
      minWidth: 100,
    },
    {
      name: () => that.$t("overseas") + that.$t("order_desc"),
      key: "overseaRemarks",
      align: "center",
      minWidth: 100,
      component: "a",
      methods: {
        async click({ row }) {
          that.openLoading();
          let list = (
            await that.handleRequestMethods("getRemark", {
              airway_number: row.airway_number,
            })
          ).payload;
          that.getModal("remarkList").open(row, function () {
            this.setTitle(
              that.$t("overseas") +
              that.$t("order_desc") +
              "：" +
              row.airway_number
            );
            this.list = list;
            that.closeLoading();
          });
        },
      },
      show: () => all,
    },
    {
      name: () => that.$t("print") + that.$t("time"),
      key: "print_time",
      align: "center",
      minWidth: 110,
      methods: {
        render({ value }) {
          return value ? value : this.$t("Not") + this.$t("print");
        },
      },
    },
    {
      name: () => that.$t("bagNum"),
      key: "package_number",
      align: "center",
      minWidth: 130,
      header: {
        copy: true
      }
    },
    {
      name: () => that.$tz("B2B,关联单号"),
      key: "b2b_airway_number",
      minWidth: 110,
      show: all,
      header: {
        copy: true
      }
    },
    {
      type: "btns",
      width: customerIn ? 130 : 100,
      name: () => that.$t("operation"),
      fixed: "right",
      showOverflow: false,
      list: [
        // {
        //   name: () => that.$t("show"),
        //   type: "showDetail",
        //   fnName: "showDetail",
        //   bind: {
        //     type: "primary",
        //   },
        //   show: () => del,
        // },
        {
          name: () => that.$t("trajectory"),
          type: "showStatus",
          fnName: "showStatus",
          bind: {
            type: "primary",
          },
          show: () => !del,
        },
        {
          name: () => that.$t("入库图"),
          type: "showInboundPicture",
          fnName: "showInboundPicture",
          bind: {
            type: "default",
          },
          show: () => !del,
        },
        {
          name: () => that.$t("planReturn"),
          type: "planReturn",
          fnName: "planReturn",
          id: 560,
          show: () => customerIn,
          bind: {
            type: "warning",
          },
        },
        {
          name: () => that.$t("operationLog"),
          type: "operationLog",
          fnName: "operationLog",
          bind: {
            type: "primary",
          },
          id: 1521,
        },
      ],
      methods: {
        operationLog({ row }) {
          that.handleRequestMethods('log', { awb: row.airway_number }, false, true).then(res => {
            that.getModal("log").open({}, function () {
              this.list = res.payload
              this.setTitle(row.airway_number + "(" + this.$t("operationLog") + ")");
            });
          })
        },
        showDetail({ row }) {
          that
            .handleRequestMethods("getOrderDetails", row.airway_number)
            .then((res) => {
              that.getModal("orderDetail").open({
                dataDetails: res.payload,
                pageText: type,
              });
            });
        },
        showStatus({ row }) {
          that.getModal("orderTracker").open(
            {
              id: row.airway_number,
            },
            function () {
              this.setTitle(row.airway_number);
            }
          );
        },
        showInboundPicture({row}) {
          // 先读取是否有入库图
          getInboundProof({keywords: row.airway_number, channel: 'OMS'}).then(res => {
            if (res.data.code) {
              that.$Message.error(res.data.msg);
            } else {
              that.getModal("inboundProof").open({src: res.data.payload.src})
            }
          })
        },
        planReturn({ row }) {
          that.getModal("planReturn").open(
            {
              id: row.airway_number,
            },
            function () {
              this.setTitle(that.$t("planReturn") + " " + row.airway_number);
            }
          );
        },
      },
    },
  ];
};
